export const stringToPhoneString = (rawPhone: string) => {
  if (!rawPhone) return rawPhone;

  return `(${rawPhone.slice(0, 3)}) ${rawPhone.slice(3, 6)}-${rawPhone.slice(6, 10)}`;
};

export const generateString = () => Math.random().toString(36).slice(2);

export const stringToErrorString = (str: string): string => `Error: ${str}`;

export const getCookieFromCookiesString = ({
  cookies,
  cookieName,
}: {
  cookies: string;
  cookieName: string;
}): string => {
  const a = `; ${cookies}`.match(`;\\s*${cookieName}=([^;]+)`);
  return a ? a[1] : '';
};

export const isString = (argument: any): boolean => {
  if (typeof argument === 'string' || argument instanceof String) return true;
  return false;
};
